import { createAction, createReducer } from "redux-act";
import undoable from "redux-undo";
import { MapState } from "@evergis/react";
import { reducerRegistry } from "../reducerRegistry";

export type MapViewState = {
  position: MapState["position"] | null;
  resolution: MapState["resolution"] | null;
};

export const reducerName = "mapView";

export const defaultState: MapViewState = {
  position: null,
  resolution: null,
};

export const setMapView = createAction<MapState>("map-view/set");

export const reset = createAction("map-view/reset");
export const undo = createAction("map-view/undo");
export const redo = createAction("map-view/redo");

export const baseReducer = createReducer({}, defaultState);

baseReducer.on(setMapView, (state, mapView) => ({ ...state, ...mapView }));

export const reducer = undoable(baseReducer, {
  limit: 10,
  undoType: undo.getType(),
  redoType: redo.getType(),
  clearHistoryType: reset.getType(),
  ignoreInitialState: true,
});

reducerRegistry.register(reducerName, reducer);
